import { API_ENDPOINTS } from "@/api/services/Settings/apiEndpoint";
import { baseApi } from "@/utils/baseApi";

export const organizationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchOrganizations: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ORGANIZATION.FETCH_ORGANIZATION(),
        method: "GET",
      }),
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "Organization", id: "LIST" }]
          : [{ type: "Organization", id: "LIST" }],
    }),

    fetchLogo: builder.query({
      query: (logoId) => ({
        url: API_ENDPOINTS.ORGANIZATION.FETCH_ORGANIZATION_LOGO(logoId),
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
      transformResponse: (blob) => URL.createObjectURL(blob), // ✅ Converts blob to URL (serializable)
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "Organization", id: "LIST" }]
          : [{ type: "Organization", id: "LIST" }],
    }),

    addOrganization: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.ORGANIZATION.ADD_ORGANIZATION(),
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "Organization", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),

    updateOrganization: builder.mutation({
      query: ({ id, formData }) => ({
        url: API_ENDPOINTS.ORGANIZATION.UPDATE_ORGANIZATION(id),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "Organization", id: "LIST" }],
      // extraOptions: { isMultipart: true },
    }),

    deleteOrganization: builder.mutation({
      query: (id) => ({
        url: API_ENDPOINTS.ORGANIZATION.DELETE_ORGANIZATION(id),
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Organization", id: "LIST" }],
    }),

    updateOrganizationStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `${API_ENDPOINTS.ORGANIZATION.UPDATE_ORGANIZATION_STATUS(id)}`,
        method: "PUT",
        body: { status },
      }),
      invalidatesTags: [{ type: "Organization", id: "LIST" }],
    }),
    fetchCountry: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ORGANIZATION.COUNTRY_DROPDOWN,
        method: "GET",
      }),
    }),

    fetchProvider: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ORGANIZATION.SMTP_DROPDOWN,
        method: "GET",
      }),
    }),

    fetchState: builder.query({
      query: (country) => ({
        url: API_ENDPOINTS.ORGANIZATION.STATE_DROPDOWN(country),
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),

    fetchSmtpServer: builder.query({
      query: (provider) => ({
        url: API_ENDPOINTS.ORGANIZATION.SMTP_SERVER_DROPDOWN(provider),
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),

    fetchTown: builder.query({
      query: ({ state, country }) => ({
        url: API_ENDPOINTS.ORGANIZATION.TOWN_DROPDOWN(state, country),
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),

    getTown: builder.query({
      query: ({ state, country }) => ({
        url: API_ENDPOINTS.ORGANIZATION.TOWN_DROPDOWN(state, country),
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),

    smtpPort: builder.query({
      query: ({ provider, server }) => ({
        url: API_ENDPOINTS.ORGANIZATION.SMTP_PORT_DROPDOWN(provider, server),
        method: "GET",
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const {
  useFetchOrganizationsQuery,
  useLazyFetchLogoQuery, // ✅ Lazy query for controlled fetching
  useAddOrganizationMutation,
  useUpdateOrganizationMutation,
  useDeleteOrganizationMutation,
  useUpdateOrganizationStatusMutation,
  useFetchCountryQuery,
  useFetchStateQuery,
  useLazyFetchTownQuery,
  useGetTownQuery,
  useFetchProviderQuery,
  useFetchSmtpServerQuery,
  useSmtpPortQuery,
} = organizationApi;
